// react-helmet-async ships as CommonJS. During SSR, Vite's module runner only
// exposes a default export; in the browser, Vite's pre-bundling exposes named
// exports. Normalize both cases here.
import * as helmetModule from "react-helmet-async";

const pkg =
  ((helmetModule as unknown as { default?: typeof helmetModule }).default ??
    helmetModule) as typeof helmetModule;

export const Helmet = pkg.Helmet;
export const HelmetProvider = pkg.HelmetProvider;
